import { Collapse, TableCell, TableRow, Button } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { toLocalTime, toUTC } from "../../formatUTC";
import Loading from "../../loading";
import Snackbar from "../../snackbar";
import UserVoucher from "../userVoucher";
import CardVoucher from "./cardVoucher";
import MultiChip from "./multiChips";
import { styles } from "./styles";
import TableFormat from "../../../partials/TableFormat";
import PriceFormat from "../../../partials/priceFormat";
const headCells = [
  {
    key: "code",
    numeric: false,
    disablePadding: false,
    label: "voucher_listvoucher_tablehead_voucher_code",
  },
  {
    key: "title",
    numeric: false,
    disablePadding: false,
    label: "voucher_listvoucher_tablehead_voucher_title",
  },
  {
    key: "discount",
    numeric: false,
    disablePadding: false,
    label: "voucher_listvoucher_tablehead_discount",
  },
  {
    key: "type",
    numeric: false,
    disablePadding: false,
    label: "voucher_listvoucher_tablehead_type",
  },
  {
    key: "startedDate",
    numeric: false,
    disablePadding: false,
    label: "voucher_listvoucher_tablehead_start_date",
  },
  {
    key: "endedDate",
    numeric: false,
    disablePadding: false,
    label: "voucher_listvoucher_tablehead_end_date",
  },
  {
    key: "arrBranch",
    numeric: false,
    disablePadding: false,
    label: "voucher_listvoucher_tablehead_branch",
  },
  { key: "action", numeric: false, disablePadding: false, label: "action" },
];
class ListVoucher extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: [],
      index: 0,
      data: [],
      voucher: [],
      editVoucher: {
        type: "",
        discount: "",
      },
      dialog: {
        messageConfirm: "",
        content: "",
      },
      edit: {
        flag: false,
        row: null,
      },
      selectedBranch: "",
      applyBranch: [],
      collapse: [],
      flagOpen: false,
      voucherSend: "",
    };
    this.mTable = React.createRef({});
    this.showDialogAddCustomer = this.showDialogAddCustomer.bind(this);
    // this.handleSubmitUpdate = this.handleSubmitUpdate.bind(this);
    this.handleSubmitDelete = this.handleSubmitDelete.bind(this);
    this.changeArrBranch = this.changeArrBranch.bind(this);
  }
  async componentDidMount() {
    this.props.onRef(this);
    this.setState({ selectedBranch: this.props.voucherState.selectedBranch });
  }
  getVoucher = async (payload) => {
    let { rowsPerPage, page, search } = this.mTable.state;
    this.loading.startLoading();
    let check = await this.props.voucherDispatch.getVoucher({
      limit: rowsPerPage,
      page: page,
      search: search,
      ...payload,
    });
    this.loading.stopLoading();
    if (check.code !== 1) this.mSnackbar.handleClick(check.message, "error");
  };
  handleDialogEditClose = () => {
    this.setState({ flagOpen: false });
  };
  showDialogAddCustomer(voucher) {
    let voucherSend = { code: voucher.code };
    this.setState({
      flagOpen: true,
      voucherSend: voucherSend,
    });
  }
  actionDialog = () => {
    var { t } = this.props;
    if (this.state.dialog.messageConfirm === t("voucher_listvoucher_delete")) {
      this.handleSubmitDelete();
    } else if (
      this.state.dialog.messageConfirm === t("voucher_listvoucher_update")
    ) {
      this.handleSubmitUpdate();
    }
  };

  getFormattedDate = (date) => {
    return toLocalTime(date);
  };

  handleSelectAllClick = (event, checked) => {
    if (checked) {
      this.setState((state) => ({
        selected: this.props.voucherState.voucherList.map((n) => n.code),
      }));
      return;
    }
    this.setState({ selected: [] });
  };

  handleClick = (event, id) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    this.setState({ selected: newSelected }, function () {});
  };
  isSelected = (id) => {
    return this.state.selected.indexOf(id) !== -1;
  };

  handleInputChange = (name, value) => {
    var editVoucher = this.state.editVoucher;
    editVoucher[name] = value;
    this.setState({ editVoucher });
  };
  handleChangeDate = (name, date) => {
    var editVoucher = this.state.editVoucher;
    editVoucher[name] = date._d;
    this.setState({ editVoucher });
  };
  handleOpenCollapes = (id) => {
    const voucherList = this.props.voucherState.voucherList;
    const collapse = this.state.collapse;
    for (var i = 0; i <= voucherList.length; i++) {
      if (i === id) {
        collapse[i] = !collapse[i];
      } else {
        collapse[i] = false;
      }
    }
    this.setState(collapse);
  };

  async handleSubmitUpdate() {
    var { t } = this.props;
    var editVoucher = this.state.editVoucher;
    editVoucher.startedDate = toUTC(editVoucher.startedDate);
    editVoucher.endedDate = toUTC(editVoucher.endedDate);
    var arrBranch = this.props.voucherState.voucher[this.state.index].arrBranch;
    let check = await this.props.voucherDispatch.updateVoucher({
      voucher: editVoucher,
      arrBranch: arrBranch,
    });
    if (check.code === 1) {
      // this.mDialog.handleDialogClose()
      this.mSnackbar.handleClick(t("voucher_listvoucher_update_successfully"));
      this.getVoucher({ branchCode: this.props.voucherState.selectedBranch });
    } else {
      // this.mDialog.handleDialogClose()
      this.mSnackbar.handleClick(
        t("voucher_listvoucher_update_unsuccessfully") + " " + check.message,
        "error"
      );
    }
    this.handleOpenCollapes(editVoucher);
    this.setState({
      edit: {
        flag: false,
      },
    });
  }

  async handleSubmitDelete(selected) {
    var { t } = this.props;
    let check = await this.props.voucherDispatch.deleteVoucher({
      listVoucherDelete: selected,
    });
    if (check.code === 1) {
      this.mSnackbar.handleClick(t("voucher_listvoucher_delete_successfully"));
      return true;
    } else {
      this.mSnackbar.handleClick(
        t("voucher_listvoucher_delete_unsuccessfully") + " " + check.message,
        "error"
      );
      return false;
    }
  }
  changeArrBranch = (index, arrBranch) => {
    this.props.voucherDispatch.changeVoucherBranch({
      index: index,
      data: JSON.stringify(arrBranch),
    });
  };
  handleChange = (value) => {
    this.props.voucherDispatch.changeSelectedBranch(value);
    this.getVoucher({ branchCode: value });
  };
  finishUpdate = (check) => {
    let { t } = this.props;
    this.handleOpenCollapes(-1);
    check.code === 1
      ? this.mSnackbar.handleClick(t("voucher_listvoucher_update_successfully"))
      : this.mSnackbar.handleClick(
          t("voucher_listvoucher_update_unsuccessfully") + " " + check.message,
          "error"
        );
    this.getVoucher({ branchCode: this.props.voucherState.selectedBranch });
  };
  finishUpdateImageGallery = () => {
    this.getVoucher({ branchCode: this.props.voucherState.selectedBranch });
  };
  renderCollapse = (row, index) => {
    const { collapse = [] } = this.state;
    const { voucherList } = this.props.voucherState;
    const { classes } = this.props;
    return (
      <TableRow key={index}>
        <TableCell
          colSpan={headCells.length + 1}
          padding={"none"}
          className={classes.tableCellInCollapes}
        >
          <Collapse in={collapse[index]} unmountOnExit>
            <CardVoucher
              data={voucherList.find((e) => e.code === row.id)}
              finishUpdate={this.finishUpdate}
              finishUpdateImageGallery={this.finishUpdateImageGallery}
            />
          </Collapse>
        </TableCell>
      </TableRow>
    );
  };
  actionColumn = (row, index) => {
    let { t, classes } = this.props;
    // const {voucherList} = this.props.voucherState
    // let voucherSend = voucherList.find(e => e.code === index)
    return (
      <div className={classes.containerButton}>
        <Button
          size="small"
          onClick={(event) => this.showDialogAddCustomer(row)}
          variant="outlined"
          color="primary"
          className={classes.buttonOnRow}
        >
          {t("sendButton")}
        </Button>
      </div>
    );
  };
  render() {
    const { t, currencyCode, total, voucherList, count } = this.props;
    const { collapse = [] } = this.state;
    const { infoServiceBranch } = this.props.serviceBranchState;
    let ofBranch =
      infoServiceBranch && infoServiceBranch.branchName
        ? ` ${t("of")} ${infoServiceBranch.branchName}`
        : "";
    return (
      <>
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <Loading onRef={(id) => (this.loading = id)} />
        <TableFormat
          onRef={(ref) => (this.mTable = ref)}
          contentDialog={t(
            "voucher_listvoucher_do_you_want_to_delete_this_voucher_from_list"
          )}
          onDelete={this.handleSubmitDelete}
          title={t("voucher_listvoucher_tabletoolbar_all_voucher") + ofBranch}
          showFilter={false}
          placeholder={t("voucher_search_code")}
          headCells={headCells}
          totalCount={total}
          count={count}
          size={"medium"}
          isCollapse={true}
          collapse={collapse}
          renderCollapse={this.renderCollapse}
          handleOpenCollapes={this.handleOpenCollapes}
          getList={this.getVoucher}
          infoServiceBranch={infoServiceBranch}
          actionColumn={this.actionColumn}
          showFilterBranch={true}
          handleChangeBranch={this.handleChange}
          rows={voucherList.map((row) => {
            let discount =
              row.type === "percent" ? row.discount * 100 : row.discount;
            // let suffixDiscount = row.type === "percent" ? "%" : currencyCode;
            return {
              id: row.code,
              code: row.code,
              title: row.title,
              discount: (
                <PriceFormat value={discount} hideCurrencyCode={true} />
              ),
              type: row.type === "value" ? currencyCode : t(row.type),
              startedDate: this.getFormattedDate(row.startedDate),
              endedDate: this.getFormattedDate(row.endedDate),
              arrBranch: (
                <MultiChip
                  forAll={row.forAll}
                  hideDelete={true}
                  isDisabled={true}
                  value={row.arrBranch}
                  arrBranch={this.changeArrBranch}
                />
              ),
            };
          })}
        />
        {this.state.flagOpen ? (
          <div>
            <UserVoucher
              handleDialogEditClose={this.handleDialogEditClose}
              dialogOpen={this.state.flagOpen}
              voucherSend={this.state.voucherSend}
            />
          </div>
        ) : (
          ""
        )}
      </>
    );
  }
}

ListVoucher.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  voucherList: state.voucher.voucherList,
  total: state.voucher.total,
  count: state.voucher.count,
  voucherState: state.voucher,
  serviceBranchState: state.serviceBranch,
  currencyCode: state.setting.setting
    ? state.setting.setting.currencyCode
    : "VND",
});

const mapDispatch = (dispatch) => ({
  voucherDispatch: dispatch.voucher,
});
export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(ListVoucher)
  )
);
